import { useShell } from '../../layout'
import { CenteredBox, H3 } from '../../widgets'

export const InProgress = ({ active }) => {
  useShell({ active, mode: 'logo' })

  return (
    <CenteredBox fullWidth height="100dvh" background="var(--red-fade)">
      <H3>The Squiz is in progress</H3>
    </CenteredBox>
  )
}